<template>
<v-content class="spinelab-website-front">
  <v-container fluid fill-height>
    <v-flex xs12 sm8 md6 offset-md3>
      <v-card>
        <v-card-title primary-title>
          <v-spacer></v-spacer>
          <h1>パスワードを忘れた方</h1>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-text-field
               label="E-mailアドレス"
               v-model="email"
               required>
            </v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="submit"
            color="success"
            :disabled="!email"
            :loading="loading">
            リセットメールを送信
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-card-text :class="$style.center">
          <router-link to="login">
            ログインページ
          </router-link>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</v-content>
</template>

<script>
import { sendResetEmail } from '@/utils/Requests';

export default {
  name: 'PasswordReset',
  data() {
    return {
      email: '',
      loading: false,
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      await sendResetEmail(this.email);
      this.loading = false;
    },
  },
};
</script>

<style module>
.center {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/PasswordReset.vue